import React from 'react'
import {
  notFoundContainer,
  notFoundContainerOverlay,
  notFoundContentCard,
  notFoundContentHeader,
  notFoundContentHeaderImage,
} from './NotFoundPageContent.css'
import { ButtonComponent, ImageFit } from '@/components/commons'
import { UserContext } from '../../context'
import Link from 'next/link'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'

export const NotFoundPageContent = () => {
  const { isAuthenticated } = React.useContext(UserContext)
  return (
    <div className={notFoundContainer}>
      <div className={notFoundContainerOverlay} />
      <div className={notFoundContentCard}>
        <div className={notFoundContentHeader}>
          <div className={notFoundContentHeaderImage} style={{ zIndex: 4 }}>
            <ImageFit
              src={`${IMAGE_PATHS_V2.system}exclamation_mark.png`}
              alt=""
            />
          </div>
          <div className={notFoundContentHeaderImage} style={{ zIndex: 3 }}>
            <ImageFit
              src={`${IMAGE_PATHS_V2.creatorsCard}creator_image_blurred_2.png`}
              alt=""
            />
          </div>
          <div className={notFoundContentHeaderImage} style={{ zIndex: 2 }}>
            <ImageFit
              src={`${IMAGE_PATHS_V2.creatorsCard}creator_image_blurred_3.png`}
              alt=""
            />
          </div>
          <div className={notFoundContentHeaderImage} style={{ zIndex: 1 }}>
            <ImageFit
              src={`${IMAGE_PATHS_V2.creatorsCard}creator_image_blurred_4.png`}
              alt=""
            />
          </div>
        </div>
        <h2 className="text-20 text-24--tablet font-medium m-0 text-primary">
          Page Not Found
        </h2>
        <p className="m-0 text-center text-secondary">
          {!isAuthenticated
            ? 'Connect with amazing creators and professionals on Creatorland.'
            : "It looks like the page that you're looking for could not be found. Please go back to the home page."}
        </p>
        <div
          className="flex flex-column gap-20 items-stretch"
          style={{ width: '100%' }}
        >
          {!isAuthenticated ? (
            <>
              <Link href="/login">
                <ButtonComponent
                  variation="secondary"
                  style={{ width: '100%' }}
                  label="SIGN IN"
                />
              </Link>
              <p className="m-0 text-center text-secondary">
                New to Creatorland?
              </p>
              <Link href="/signup">
                <ButtonComponent
                  label="Join creatorland now"
                  style={{ width: '100%' }}
                />
              </Link>
            </>
          ) : (
            <Link href="/">
              <ButtonComponent label="Home" style={{ width: '100%' }} />
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
